import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const RecoveryApi = createApi({
  reducerPath: "RecoveryApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getRecoveryData: builder.query({
      query: () => "/sales/recovery_data",
      transformResponse: (response) => response,
    }),
    getInvoiceRecoveryData: builder.query({
      query: () => "/sales/invoice_recovery_data",
      transformResponse: (response) => response?.data,
    }),
    getFollowUpDataById: builder.query({
      query: (id) => `/sales/recovery/${id}`,
      transformResponse: (response) => response?.data,
    }),

    // getCountExecutionCampStatus: builder.query({
    //     query: () => `count_exe_campaign_status`,
    //     transformResponse: (response) => response?.data,
    // }),
    // getCampaignDataStatusWise: builder.query({
    //     query: (status) => `campaigns_with_status?status=${status}`,
    //     transformResponse: (response) => response?.data,
    // }),

    addFollowUp: builder.mutation({
      query: (payload) => ({
        url: `/sales/recovery`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetRecoveryDataQuery,
  useGetInvoiceRecoveryDataQuery,
  useAddFollowUpMutation,
  useGetFollowUpDataByIdQuery,
  // useGetVendorsByPageNamesMutation,
  // useGetCountExecutionCampStatusQuery,
  // useUpdatExecutionCampaignMutation,
} = RecoveryApi;

export default RecoveryApi;
